export default {
  namespaced: true,
  state: {
    snackbar: {
      show: false,
      text: "",
      color: "success",
    },
  },
  mutations: {
    showSnackbar (state, text) {
      let timeout = 0
      if (state.snackbar.show) {
        state.snackbar.show = false
        timeout = 300
      }
      setTimeout(() => {
        state.snackbar.show = true
        state.snackbar.text = text
      }, timeout)
    },
    hideSnackbar (state) {
      state.snackbar.show = false
    },
    setShow (state, value) {
      // console.log("setShow(state, value) value=" + value);
      state.snackbar.show = value
    },
    setColor (state, color) {
      // console.log("color=" + color);
      if (color !== undefined) {
        state.snackbar.color = color
      }
    },
  },
  actions: {
    showSnackbar (context, payload) {
      // console.log("->color=" + payload);
      context.commit("showSnackbar", payload.text)
      context.commit("setColor", payload.color)
    },
  },
  getters: {
    getShow (state) {
      return state.snackbar.show
    },
    getText (state) {
      return state.snackbar.text
    },
    getColor (state) {
      return state.snackbar.color
    },
  },
}
